import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';

interface DialogData {

}

@Component({
  selector: 'app-new-post-process',
  templateUrl: './new-post-process.component.html',
  styleUrls: ['./new-post-process.component.scss']
})
export class NewPostProcessComponent implements OnInit {


  newPostProcessForm: FormGroup;
  isPostProcessAdded = false;

  constructor(
    private fb: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    public dialogref: MatDialogRef<NewPostProcessComponent>,
    private toastr:ToastrService
  ) { }

  ngOnInit() {

    this.newPostProcessForm = this.fb.group({
      'new_post_process_name': ["", [Validators.required, Validators.minLength(2)]],
    });

  }

  cancel() {
    this.dialogref.close();
  }

  submit() {
    if (this.newPostProcessForm.valid) {
      this.dialogref.close({ data: this.newPostProcessForm.value })
    }
    else{
      return this.toastr.error('Entered post process is not valid','Error')
    }

  }
}
